import React from 'react';

interface SourceLegendProps {
  total: number;
  agendaPercentage: number;
  walkInPercentage: number;
}

export const SourceLegend: React.FC<SourceLegendProps> = ({
  total,
  agendaPercentage,
  walkInPercentage,
}) => {
  return (
    <div className='grid grid-cols-2 gap-6 items-center'>
      <div className='space-y-1 px-1 text-center bg-slate-50 py-3 rounded-2xl border border-slate-100'>
        <span className='block text-4xl font-[1000] text-slate-900 tracking-tighter'>
          {total}
        </span>
        <span className='block text-[10px] font-black text-slate-400 uppercase tracking-[0.2em]'>
          Tickets Totales
        </span>
      </div>

      <div className='flex flex-col justify-center items-end text-right px-1 gap-2'>
        <div className='flex items-center gap-2 group cursor-default'>
          <span className='text-xs font-black text-slate-600 uppercase tracking-tighter group-hover:text-indigo-600 transition-colors'>
            Agendados: {agendaPercentage.toFixed(1)}%
          </span>
          <div className='w-3 h-3 rounded-full bg-indigo-500 shadow-sm shadow-indigo-200' />
        </div>
        <div className='flex items-center gap-2 group cursor-default'>
          <span className='text-xs font-black text-slate-600 uppercase tracking-tighter group-hover:text-amber-600 transition-colors'>
            Espontáneos: {walkInPercentage.toFixed(1)}%
          </span>
          <div className='w-3 h-3 rounded-full bg-amber-500 shadow-sm shadow-amber-200' />
        </div>
      </div>
    </div>
  );
};
